<div
  class="adjunto-mini-card"
  [class.is-uploaded]="tipo.estado === 'subido'"
  [class.is-uploading]="tipo.isUploading"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)">

  <div class="d-flex align-items-center">
    <!-- Ícono pequeño -->
    <div class="adjunto-icon-mini me-3">
      <i [class]="utility.getFileIcon(tipo.archivo_nombre)"></i>
    </div>

    <!-- Info -->
    <div class="flex-grow-1 overflow-hidden">
      <div class="text-truncate fw-medium mb-1" style="font-size: 0.875rem;">
        {{ tipo.nombre }}
      </div>

      <small class="text-muted d-block text-truncate" *ngIf="tipo.estado === 'pendiente'">
        Sin archivo
      </small>

      <small class="text-success d-block text-truncate" *ngIf="tipo.estado === 'subido'">
        {{ tipo.archivo_nombre }}
      </small>

      <small class="text-primary d-block" *ngIf="tipo.isUploading">
        <span class="spinner-border spinner-border-sm me-1" style="width: 0.75rem; height: 0.75rem;"></span>
        Subiendo...
      </small>
    </div>

    <!-- Acciones -->
    <div class="ms-2 d-flex gap-2">
      <!-- Subir -->
      <label
        *ngIf="tipo.estado === 'pendiente' && !tipo.isUploading"
        class="btn btn-sm btn-soft-primary mb-0"
        [for]="'file-' + tipo.id"
        style="cursor: pointer;">
        <i class="ri-upload-2-line"></i>
        <input
          type="file"
          [id]="'file-' + tipo.id"
          class="d-none"
          (change)="onFileSelected($event)">
      </label>

      <!-- Botón de Validación (solo si requiere validación) -->
      <button
        *ngIf="tipo.requiereValidacion && tipo.archivo_id && !tipo.validado"
        type="button"
        class="btn btn-sm btn-success"
        (click)="onValidarDocumento()"
        title="Click aquí para validar el documento">
        <i class="ri-check-fill"></i>
      </button>

      <!-- Ver Archivo (solo ícono) -->
      <button
        *ngIf="tipo.estado === 'subido' && !tipo.isUploading && tipo.archivo_url"
        type="button"
        class="btn btn-sm btn-info"
        (click)="onVerArchivo()"
        title="Ver archivo">
        <i class="ri-eye-line"></i>
      </button>

      <!-- Eliminar -->
      <button
        *ngIf="tipo.estado === 'subido' && !tipo.isUploading"
        type="button"
        class="btn btn-sm btn-soft-danger"
        (click)="onEliminarArchivo()">
        <i class="ri-delete-bin-line"></i>
      </button>
    </div>
  </div>

  <!-- Overlay drag -->
  <div *ngIf="isDragging && currentUploadingTipo === tipo.id" class="drag-overlay-mini">
    <i class="ri-upload-cloud-2-line"></i>
  </div>
</div>
